import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChangeRegisterPeristenceService {
  panelListView$ = new BehaviorSubject<number>(0);


  updatePanelListView(panelListView : number){
      this.panelListView$.next(panelListView);
  }
  constructor() { }
}
